import React from "react";
import Preloader from "../helper/Preloader";
 import Breadcrumb from "../components/Breadcrumb";
 import BottomFooter from "../components/BottomFooter";
import ShippingOne from "../components/ShippingOne";
 import ScrollToTop from "react-scroll-to-top";
  import VendorProfileView from "../componentsAmazon/VendorProfileView";
 import HeaderOneCustomer from "../componentsAmazon/HeaderOneCustomer";

const ProfileVendorAmazon = () => {
  return (
    <>

      {/* ScrollToTop */}
      <ScrollToTop smooth color="#232F3F" />

      {/* Preloader */}
      <Preloader />

      {/* HeaderOneCustomer */}
      <HeaderOneCustomer/>

      {/* Contact */}
      <VendorProfileView/>

      {/* ShippingOne */}
      <ShippingOne />
 

      {/* BottomFooter */}
      <BottomFooter />
    </>
  );
};

export default ProfileVendorAmazon;
